import { SvgIcon, SvgIconProps } from "@mui/material";
import { memo } from "react";
const SvgCheckmark32 = (props: SvgIconProps) => {
  const {
    sx,
    ...other
  } = props;
  return <SvgIcon xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" sx={{
    ...sx
  }} {...other}><path fill="currentColor" fillRule="evenodd" d="M21.207 13.707a1 1 0 0 0-1.414-1.414L14.5 17.586l-2.293-2.293a1 1 0 0 0-1.414 1.414l3.707 3.707z" clipRule="evenodd" /></SvgIcon>;
};
const Memo = memo(SvgCheckmark32);
export default Memo;